import type { AxiosError } from 'axios'

export const INSUFFICIENT_CREDITS_MESSAGE =
  'Your organization does not have enough credits to start postprocessing. ' +
  'Please recharge your credits and try again.'

/** Pull a human message out of a Micronaut error body, which may nest it under `_embedded.errors`. */
const messageFromBody = (data: unknown): string | undefined => {
  if (typeof data === 'string') {
    return data || undefined
  }
  if (data && typeof data === 'object') {
    const top = (data as { message?: unknown }).message
    if (typeof top === 'string' && top) {
      return top
    }
    const embedded = (data as { _embedded?: { errors?: Array<{ message?: unknown }> } })._embedded?.errors?.[0]?.message
    if (typeof embedded === 'string' && embedded) {
      return embedded
    }
  }
  return undefined
}

/**
 * S2-956: a force-submit that fails on insufficient credits returns 402. Prefer the backend's
 * specific message ("X available, Y required…"), but always fall back to a clear recharge prompt
 * so the user never just sees a bare "402".
 */
export const getErrorMessage = (error: AxiosError | Error): string => {
  if ('response' in error) {
    const fromBody = messageFromBody(error.response?.data)
    if (fromBody) {
      return fromBody
    }
    if (error.response?.status === 402) {
      return INSUFFICIENT_CREDITS_MESSAGE
    }
  }

  return error.message || 'Failed to start postprocessing'
}
